module.exports = __webpack_public_path__ + "images/emoji/virgo.8958f28f74921fec54ff.png";